import { ProductChildPromotion } from "@/types/Product.type";

export function convertPromotionChild(data?: ProductChildPromotion[]) {
	return {
		promotions: data?.flatMap((product) => product.promotions) || [],
	};
}
